/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Line_Up_TitleInputs */

const en_position_line_up_title = /** @type {(inputs: Position_Line_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Up One Line`)
};

const fr_position_line_up_title = /** @type {(inputs: Position_Line_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monter d'Une Ligne`)
};

const de_position_line_up_title = /** @type {(inputs: Position_Line_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Zeile nach oben rücken`)
};

const it_position_line_up_title = /** @type {(inputs: Position_Line_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spostati di una riga in su`)
};

const ru_position_line_up_title = /** @type {(inputs: Position_Line_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместитесь на одну строку вверх`)
};

const es_position_line_up_title = /** @type {(inputs: Position_Line_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir una línea`)
};

const zh_cn2_position_line_up_title = /** @type {(inputs: Position_Line_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向上移动一行`)
};

const ja_position_line_up_title = /** @type {(inputs: Position_Line_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行上に移動`)
};

const hi_position_line_up_title = /** @type {(inputs: Position_Line_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक पंक्ति ऊपर जाएं`)
};

const pt_pt2_position_line_up_title = /** @type {(inputs: Position_Line_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir uma linha`)
};

/**
* | output |
* | --- |
* | "Move Up One Line" |
*
* @param {Position_Line_Up_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_line_up_title = /** @type {((inputs?: Position_Line_Up_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Line_Up_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_line_up_title(inputs)
	if (locale === "de") return de_position_line_up_title(inputs)
	if (locale === "it") return it_position_line_up_title(inputs)
	if (locale === "ru") return ru_position_line_up_title(inputs)
	if (locale === "es") return es_position_line_up_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_line_up_title(inputs)
	if (locale === "ja") return ja_position_line_up_title(inputs)
	if (locale === "hi") return hi_position_line_up_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_line_up_title(inputs)
	return en_position_line_up_title(inputs)
});